import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import CityConfigServices from "../services/externalServices/cityConfigServices";

function City() {
  const [cities, setCities] = useState([]);


  useEffect(() => {
    getCity();
  }, []);

  
  const getCity = async () => {
    const response = await CityConfigServices.getCityConfig();
    console.log("city response", response);

    // Mapping through the response array and updating city names
    const updatedCities = response.map((city) => {
      if (city.block === 1) {
        return { ...city, city: "Hospet" };
      } else if (city.block === 2) {
        return { ...city, city: "Bellary" };
      } else {
        return city;
      }
    });

    setCities(updatedCities);
  };
  return (
    <div className="row mt-3">
      <div className="col-sm-6">
        <div className="card">
          <div className="card-body">
            <h4 className="card-title">Hospet</h4>
            <p className="card-text">ID:12345</p>
            <p className="card-text">Created At: 12/1/2024 </p>

            {/* <p className="card-text">
              With supporting text below as a natural lead-in to additional
              content.
            </p> */}
            {/* <a href="/city/details" className="btn btn-primary">
              Full Details
            </a> */}
            <Link to="/city/details" className="btn btn-primary">
              Full Details
            </Link>
          </div>
        </div>
      </div>
      <div className="col-sm-6">
        <div className="card">
          <div className="card-body">
            <h5 className="card-title">Bellary</h5>
            <p className="card-text">ID:12345</p>
            <p className="card-text">Created At: 12/1/2024 </p>
            {/* <p className="card-text">
              With supporting text below as a natural lead-in to additional
              content.
            </p> */}
            <Link to="/city/details" className="btn btn-primary">
              Full Details
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default City;


// import React, { useEffect, useState } from "react";
// import { Link } from "react-router-dom";
// import CityConfigServices from "../services/externalServices/cityConfigServices";

// function City() {
//   const [cities, setCities] = useState([]);

//   useEffect(() => {
//     getCity();
//   }, []);

//   const getCity = async () => {
//     const response = await CityConfigServices.getCityConfig();
//     console.log("city response", response);

//     setCities(response);
//   };

//   return (
//     <div className="row mt-3">
//       <div className="col-sm-6">
//         <div className="card">
//           <div className="card-body">
//             <h4 className="card-title">Hospet</h4>
//             {cities
//               .filter((city) => city.block === 1)
//               .map((city) => (
//                 <div key={city._id}>
//                   <p className="card-text">ID: {city._id}</p>
//                   <p className="card-text">Created At: {city.created_at}</p>
//                   <Link to="/city/details" className="btn btn-primary">
//                     Full Details
//                   </Link>
//                 </div>
//               ))}
//           </div>
//         </div>
//       </div>
//       <div className="col-sm-6">
//         <div className="card">
//           <div className="card-body">
//             <h5 className="card-title">Bellary</h5>
//             {cities
//               .filter((city) => city.block === 2)
//               .map((city) => (
//                 <div key={city._id}>
//                   <p className="card-text">ID: {city._id}</p>
//                   <p className="card-text">Created At: {city.created_at}</p>
//                   <Link to="/city/details" className="btn btn-primary">
//                     Full Details
//                   </Link>
//                 </div>
//               ))}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default City;


